/**
 * Blueprint registry — what the dashboard's "New app" picker offers.
 *
 * The actual file/dependency content lives in the auto-generated sibling
 * `blueprints.generated.ts` (regenerate via `npx ts-node scripts/generate-blueprints.ts`).
 * This module just wraps it with helpers and a stable default fallback.
 */
import {
  BLUEPRINTS as GENERATED_BLUEPRINTS,
  BlueprintDefinition,
  BlueprintMetadata,
} from '@/config/blueprints.generated';

export type { BlueprintDefinition, BlueprintMetadata };
export const BLUEPRINTS = GENERATED_BLUEPRINTS;

export const DEFAULT_BLUEPRINT_ID = 'default';

export function getBlueprint(id: string | undefined | null): BlueprintDefinition {
  if (!id) return defaultBlueprint();
  return BLUEPRINTS.find((b) => b.id === id) ?? defaultBlueprint();
}

export function defaultBlueprint(): BlueprintDefinition {
  const fallback = BLUEPRINTS.find((b) => b.id === DEFAULT_BLUEPRINT_ID);
  if (!fallback) {
    throw new Error(
      `Blueprint registry is empty or missing the "${DEFAULT_BLUEPRINT_ID}" blueprint. ` +
        'Did you forget to run `npx ts-node scripts/generate-blueprints.ts`?',
    );
  }
  return fallback;
}
